import { LegalShell, H } from "@/components/LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms of Service" updated="June 2026">
      <section data-testid="terms-content">
        <p>
          Welcome to Wellness Way with DJ. By using wellnesswaywithdj.com, purchasing a program,
          or joining the member portal, you agree to these terms.
        </p>
      </section>
      <section>
        <H>Not medical advice</H>
        <p className="mt-3">
          Our programs — including the Metabolic Transformation Method and Rise Within — provide
          wellness, nutrition, and fitness <em>coaching</em>. They are educational and are not
          medical advice, diagnosis, or treatment. Always consult your physician before starting
          any nutrition, supplement, or exercise program, especially if you have a medical
          condition, are pregnant, or take medication. Never disregard professional medical advice
          because of something you learned here.
        </p>
      </section>
      <section>
        <H>Results vary</H>
        <p className="mt-3">
          Client transformations shown on this site are real, but individual results depend on
          your starting point, consistency, and biology. We make no guarantee of specific
          outcomes.
        </p>
      </section>
      <section>
        <H>Purchases &amp; refunds</H>
        <p className="mt-3">
          Program fees are shown at checkout and processed securely by Stripe (including Klarna,
          Affirm, and PayPal options). Because coaching spots are limited and materials are
          delivered digitally, fees are generally non-refundable once a program begins. If
          something isn't right, email us within 7 days of purchase and we'll work with you.
          Custom payment arrangements agreed with DJ are governed by their own written terms.
        </p>
      </section>
      <section>
        <H>Your account</H>
        <p className="mt-3">
          Member portal access is personal to you. Keep your login private and don't share
          program materials — they're for enrolled members only.
        </p>
      </section>
      <section>
        <H>Intellectual property</H>
        <p className="mt-3">
          All content on this site and inside the member portal — the MTM curriculum, guides,
          videos, and branding — belongs to Wellness Way with DJ and may not be copied,
          resold, or redistributed.
        </p>
      </section>
      <section>
        <H>Assumption of risk &amp; limitation of liability</H>
        <p className="mt-3">
          Physical exercise carries inherent risk. By participating you accept that risk and
          agree that, to the fullest extent permitted by law, Wellness Way with DJ is not liable
          for injuries or damages arising from your participation. Our total liability for any
          claim is limited to the amount you paid for the program.
        </p>
      </section>
      <section>
        <H>Changes</H>
        <p className="mt-3">
          We may update these terms as offerings evolve; the latest version always lives on this
          page. Continued use after changes means you accept them.
        </p>
      </section>
      <section>
        <H>Contact</H>
        <p className="mt-3">
          Questions? Email <a href="mailto:dj@djheningerfitness.com" style={{ color: "#A89880" }}>dj@djheningerfitness.com</a>.
        </p>
      </section>
    </LegalShell>
  );
}
